import React from 'react';
import Svg, {SvgProps} from 'react-native-svg';

import {colors} from '../styles';
import {ColorScheme, colorScheme} from '../util/colorScheme';

export type IconProps = SvgProps & {
  /**
   * size length of the icon, default to 24
   */
  size?: number;
  /**
   * color of the icon
   */
  color?: string;
  /**
   * viewBox height
   */
  baseHeight?: number;
  /**
   * viewBox width
   */
  baseWidth?: number;
  /**
   * determine wether the icon is solid or not
   */
  solid?: boolean;
};

const iconColorSchemeMap: Record<ColorScheme, string> = {
  dark: colors.white,
  light: colors.black,
};

const defaultColor = iconColorSchemeMap[colorScheme];

export const Icon: React.FC<IconProps> = ({
  baseHeight = 24,
  baseWidth = 24,
  strokeWidth = 1.5,
  color = defaultColor,
  size,
  solid,
  style,
  ...props
}) => {
  const scale = size ? size / baseWidth : undefined;

  const height = scale ? baseHeight * scale : props.height ?? baseHeight;

  return (
    <Svg
      {...{height, strokeWidth, style}}
      width={size ?? baseWidth}
      fill={solid ? color : 'none'}
      stroke={color}
      viewBox={`0 0 ${baseWidth} ${baseHeight}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    />
  );
};
